var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.96875,
    width: 40.2327,
    height: 43,
    rx: 10,
    fill: "#2D7BEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8868 11H15.9338C15.4375 11 14.9615 11.2107 14.6106 11.5858C14.2597 11.9609 14.0625 12.4696 14.0625 13V29C14.0625 29.5304 14.2597 30.0391 14.6106 30.4142C14.9615 30.7893 15.4375 31 15.9338 31H27.1615C27.6578 31 28.1338 30.7893 28.4847 30.4142C28.8356 30.0391 29.0328 29.5304 29.0328 29V16.5L23.8868 11Z",
    stroke: "#2D7BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4219 11V17H29.0357",
    stroke: "#2D7BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2898 22H17.8047",
    stroke: "#2D7BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2898 26H17.8047",
    stroke: "#2D7BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.676 18H17.8047",
    stroke: "#2D7BEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportBlue);
export default __webpack_public_path__ + "static/media/ReportBlue.ebac7531278e2dcc4c3ffdea169721c6.svg";
export { ForwardRef as ReactComponent };